import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/PMS/customerService/statisticalReport';
import { formatDate } from '@/utils/date';
import waves from '@/directive/waves'; // 水波纹指令

export default {
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      dates: [],
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    var year = new Date().getFullYear();
    var yearFirstDay = year + '-' + '01' + '-' + '01';
    var beginDate = formatDate(new Date(yearFirstDay), 'yyyy-MM-dd').toString();
    var endDate = formatDate(new Date(Date.now()), 'yyyy-MM-dd').toString();
    this.dates.push(beginDate);
    this.dates.push(endDate);

    if (location.hash === '#/complaintManage/statisticalReport') {
      this.listQuery.sysType = 2;
    } else {
      this.listQuery.sysType = 1;
    }

    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = 1;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};